export default __webpack_public_path__ + "static/media/logoRealizandoEscolhasMobile.b7fa7033.svg";